import React, { useContext, useEffect, useRef, useState } from 'react';
import NachHistory from './NachHistory';
import { FaRegPlusSquare } from "react-icons/fa";
import PopupTable from '../TablePopUp/PopupTable';
import { useGlobalAppContext } from '../../context/Context';
import { dateTimeFormat } from '../../utils/Misc/DateTime';
import getHighestPriorityService from '../../utils/Misc/getHighestPriorityService';
import { getNachDetails } from '../../services/merpservices';
import EmployeeContext from '../../utils/EmpDetails/EmployeeProvider';

// Module-level: keyed by glid so remounts and tab switches never re-hit the API.
const _serviceDetailsCache = new Map();

const ServiceDetails = ({ empid, ak, glid }) => {
    const {showActiveServices, handleShowActiveServices, activeServiceData} = useGlobalAppContext();
    const [ecsIsActive, setEcsIsActive] = useState("0");
    const [serviceId, setServiceId] = useState(0);
    const employeeDetails = useContext(EmployeeContext);
    const fetchedGlid = useRef(null);

    const showHighestService = getHighestPriorityService(activeServiceData);
    const {SERVICE_SHORTNAME, MODE_OF_PLAN, STARTDATE, VALIDUPTO} = showHighestService;

    const serviceIds = [354, 228, 376];

    const getNachStopDetails = async () => {
      try {
        const res = await getNachDetails(
          employeeDetails?.empid,
          employeeDetails?.ak,
          glid
        );
        if (res?.data?.status === 200) {
          const ecsValue = res?.data?.data[0]?.AR_ECS_IS_ACTIVE ?? "0";
          _serviceDetailsCache.set(glid, { ecsIsActive: ecsValue });
          setEcsIsActive(ecsValue);
        }
      } catch (error) {
        console.log(error);
      }
    };

    useEffect(() => {
      if (!glid) return;
      if (_serviceDetailsCache.has(glid)) {
        setEcsIsActive(_serviceDetailsCache.get(glid).ecsIsActive);
        return;
      }
      if (fetchedGlid.current === glid) return;
      fetchedGlid.current = glid;
      getNachStopDetails();
    }, [glid]);

    // Wait until showHighestService is ready
    useEffect(() => {
        if (activeServiceData?.length > 0) {
            const serviceDetials = getHighestPriorityService(activeServiceData);
            if (serviceDetials && Object.keys(serviceDetials).length > 0) {
                setServiceId(serviceDetials?.SERVICE_ID)
            }
        }
    }, [activeServiceData]);
   

    return (
        <>
            {activeServiceData.length && ecsIsActive ? (
                <>
                    <div className="nach-details mb10">
                        <span>
                            {
                                `${SERVICE_SHORTNAME || activeServiceData[0]?.SERVICE_SHORTNAME} (${MODE_OF_PLAN || showHighestService[0]?.MODE_OF_PLAN}) `
                            }
                                {activeServiceData.length > 1 && <FaRegPlusSquare className='servicesPlusIcon cp' onClick={() => handleShowActiveServices(!showActiveServices)} />}
                        </span>
                        <span>
                            {
                                (serviceIds.includes(parseInt(serviceId || activeServiceData[0]?.SERVICE_ID)) && ecsIsActive === "0")   ? <>
                                <span className="nach-color">Start :</span> {dateTimeFormat(STARTDATE || showHighestService[0]?.STARTDATE)}
                                </>
                                 : (
                                <>
                                    <span className="nach-color">Start | End:</span>
                                    {dateTimeFormat(STARTDATE || showHighestService[0]?.STARTDATE)}
                                    <span className="nach-color"> | </span>
                                    {dateTimeFormat(VALIDUPTO || showHighestService[0]?.VALIDUPTO)}
                                </>
                                )
                            }
                        </span>
                        {
                            showActiveServices && <PopupTable data={activeServiceData} />
                        }
                    </div>
                    <NachHistory empid={empid} ak={ak} glid={glid} ecsIsActive={ecsIsActive}/>
                </>
            ) : (
                <NachHistory empid={empid} ak={ak} glid={glid} ecsIsActive={ecsIsActive} />
            )}
        </>
    );
};

export default ServiceDetails;